import { Card, Badge, Button } from 'react-bootstrap';
import { Check, RefreshCw, Package } from 'lucide-react';
import { WpUploadPreview } from './WpUploadPreview';
import type { RestructuredProduct } from '../../../../../infrastructure/SourcingClient';

interface WpUploadSectionProps {
  currentSsStructure: {
    products: RestructuredProduct[];
    stats: any;
    cpProductId: string;
  } | null;
  matchedProduct: any;
  cmWorkflowData?: any;
  matchLoading: boolean;
  refetchMatchedProduct: () => Promise<any>;
  refetchCMWorkflow?: () => Promise<any>;
  refetchProductDetails?: (forceRefresh?: boolean) => Promise<any>;
}

export const WpUploadSection = ({
  currentSsStructure,
  matchedProduct,
  cmWorkflowData,
  matchLoading,
  refetchMatchedProduct,
  refetchCMWorkflow,
  refetchProductDetails,
}: WpUploadSectionProps) => {
  const hasGeneratedSkus = cmWorkflowData?.[0]?.skuCpiiMappings?.some(
    (mapping: any) => mapping.sku && mapping.sku.trim() !== '',
  );

  return (
    <Card className="mb-4">
      <Card.Header>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2">
            <h6 className="mb-0">Upload to WordPress</h6>
            {hasGeneratedSkus ? (
              <Badge bg="success" className="d-flex align-items-center gap-1" style={{ fontSize: '0.7rem' }}>
                <Check size={12} />
                SKUs Generated
              </Badge>
            ) : (
              <Badge bg="warning" className="d-flex align-items-center gap-1" style={{ fontSize: '0.7rem' }}>
                ⚠️ No SKUs Yet
              </Badge>
            )}
          </div>
          <Button
            variant="outline-primary"
            size="sm"
            onClick={async () => {
              await refetchMatchedProduct();
              if (refetchCMWorkflow) {
                await refetchCMWorkflow();
              }
              if (refetchProductDetails) {
                await refetchProductDetails(true); // Force refresh
              }
            }}
            disabled={matchLoading}
            className="d-flex align-items-center gap-1"
          >
            <RefreshCw size={14} />
            Refresh Data
          </Button>
        </div>
      </Card.Header>
      <Card.Body>
        {currentSsStructure ? (
          <WpUploadPreview
            products={currentSsStructure.products}
            matchedProduct={matchedProduct}
            cmWorkflowData={cmWorkflowData}
            {...(refetchCMWorkflow && { refetchCMWorkflow })}
            {...(refetchProductDetails && { refetchProductDetails })}
            refetchMatchedProduct={refetchMatchedProduct}
          />
        ) : (
          <div className="text-center py-5">
            <Package size={48} className="text-muted mb-3" />
            <h5 className="mb-3">Upload Product to WordPress</h5>
            <p className="text-muted mb-4">
              Upload the restructured product with processed images to your WordPress site
            </p>
            <div className="mt-3">
              <small className="text-danger">
                Please complete Step 2 (Product Restructure) before uploading to WordPress
              </small>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};
